import * as React from "react";
import { pushSimpleEvent } from "@nju/data-layer";
import { Button, Heading, Separator, Text } from "@nju/ui";

interface IChooseNewNumberExpiredProps {
  onSubmit: () => void;
}

export function ChooseNewNumberExpired({
  onSubmit,
}: IChooseNewNumberExpiredProps) {
  React.useEffect(() => {
    pushSimpleEvent({
      event: "error_number_carousel",
      eventName: "NumbersExpired",
    });
  }, []);

  return (
    <div data-cy="list-of-number-expired-panel">
      <Heading
        className="flex justify-center font-bold mt-2 mb-2 from-tablet:mb-6"
        font="ttfirs"
        tone="neutral"
        variant="h2"
      >
        lista numerów wygasła
      </Heading>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center">
        <img
          alt="calculator-error"
          className="w-12 h-12 from-tablet:w-[90px] from-tablet:h-[90px]"
          src="/images/calculator-error.svg"
        />
      </div>
      <Separator size="s" tone="invisible" />
      <Text
        align="center"
        className="justify-center max-w-[715px] mx-auto"
        display="flex"
        size={{
          "@fromDesktop": "xl",
        }}
        weight="bold"
      >
        Odśwież listę i pamiętaj, że wyświetlane numery są dostępne tylko przez
        5 minut.
      </Text>
      <Separator size="xl" />
      <div className="flex justify-center only-mobile:flex-col">
        <Button onPress={onSubmit} size={{ "@onlyMobile": "s" }}>
          odśwież listę numerów
        </Button>
      </div>
    </div>
  );
}
